import React,{useEffect, useState} from 'react';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { clearCookieKeys, removeCookieValue, titleCase } from '../utilFunctions';
import { useMsal } from '@azure/msal-react';

const Profile = (props) => {
    const {roleDataCookie} = props
    const [openDropDown, setOpenDropDown] = useState(false)
    const [roleName, setRoleName] = useState("")
    const navigate = useNavigate();
    const {instance} = useMsal()
  
  return (
    <div>
      <div className="profile">
                <div className="profile-heading">
                    {roleDataCookie?.employeeName}
                </div>
                <div className="designation pt-1">
                    {decodeURIComponent(roleDataCookie?.roleName)}
                </div>
            </div>
            <div className="profile-photo">
                <img
                    alt="Profile-picture"
                    className="profile-photo"
                    height="40px"
                    src="/kshemaImages/Profile-picture.png"
                    title="Upload Profile Photo"
                    width="40px"

                />
            </div>
            <p className="dropdown">
            </p>
            <div
                className="dropbtn"
                id="arrow_logout"
            >
                <i className="fa fa-angle-down dropdown-arrow pointer" onClick={() => setOpenDropDown(!openDropDown)}/>
                
            {
                openDropDown && (
                    <div
                        className="dropdown-content"
                        id="btn_dropdown"
                    >
                        <a className='pointer' onClick={() => {clearCookieKeys();localStorage.removeItem("is_omdcUser");instance.logoutRedirect()}}>
                            Logout
                        </a>
                    </div>
                )
            }
            </div>
            <p />

    </div>
  )
}

export default Profile
